import * as React from "react";
import {
  Input,
  FormController,
  FormLabel,
  FormStatusMessage,
} from "@one-thd/sui-atomic-components";

export const ComposedTextFields = (props) => {
  const {
    setVerify = ()=> {},
    setOTP = ()=> {},
    otp,
    onOtpChange = ()=>{},
    errors,
    isVerified,
    submit = () => {},
    type
  } = props;

  const helperSubmitFunction = (event) => {
    if(isVerified){
      submit();
    }
    event.preventDefault();
  }

  const handleChange = (event) => {
    const otp = event.target.value.trim().replace(/[^\d]/,"");
    setOTP(otp);
    onOtpChange(event.target.value)
  };

  const verify = (otp) => {
    const regex = /^[0-9]{1,6}$/
    const found = otp.match(regex);
    if (found && otp.length === 6) {
      setVerify(true);
      return {status: "success", text: ""}
    } else if (otp.length === 0 ) {
      return {status: null, text: "Please enter your six digit code."}
    } else {
      setVerify(false);
      return {status: null, text: "The verification code must be 6 digits."}
    }
  }

  return (
    <form
      autoComplete="off"
      noValidate
      onSubmit={ helperSubmitFunction }
    >
        <FormController fullWidth status={ verify(otp).status }>
          <FormLabel htmlFor="input-error">Enter Verification Code</FormLabel>
          { errors }
          <Input
            className="full-width" 
            id="input-error" 
            value={otp} 
            onChange={handleChange} 
            aria-describedby="input-error-message" 
            type={type === "OTP" ? "tel" : type}   
            inputProps={{ maxLength: 6, 
                          inputMode: type === "OTP" ? "numeric" : "text", 
                          pattern: type === "OTP" ? "[0-9]*" : null }} />
          <FormStatusMessage id="input-error-message">{verify(otp).text}</FormStatusMessage>
        </FormController>
    </form>
  );
};